import { defineStore } from 'pinia';
import { LearningPath } from '@/v2/agents/hdtc/entities/learning-path';
export const useRegistrationDialog = defineStore('registrationDialog', {
	state: () => ({
		isOpen: false,
		data: null,
		initialPhoneNumber: null,
		initialData: null,
	}),
	actions: {
		async open(data) {
			this.data = data;
			this.initialPhoneNumber = null;
			this.initialData = null;
			this.isOpen = true;
		},
		openWithPhoneNumber(phoneNumber) {
			this.initialPhoneNumber = phoneNumber;
			this.data = null;
			this.initialData = null;
			this.isOpen = true;
		},
		async openWithInitialData(data, phoneNumber) {
			this.initialData = { ...data };
			this.initialPhoneNumber = phoneNumber;
			this.data = null;
			if (!data.learningPath) {
				const id = data.learningPathId.toString();
				this.initialData.learningPath = await LearningPath.getById(id);
			}
			this.isOpen = true;
		},
	},
});
